import { DialogContent } from '@mui/material';
import { BaseDialogContentProps } from './BaseDialogContent.types';

/**
 * BaseDialogContent component that wraps the MUI DialogContent component.
 *
 * @param ariaLabel - {@link BaseDialogContentProps.ariaLabel ariaLabel} description.
 * @param classes - {@link BaseDialogContentProps.classes classes} description.
 * @param children - {@link BaseDialogContentProps.children children} description.
 */
export const BaseDialogContent = ({
    ariaLabel,
    classes,
    children,
}: BaseDialogContentProps) => {
    return (
        <DialogContent
            aria-label={ariaLabel}
            classes={{
                ...classes,
            }}
            dividers
        >
            {children}
        </DialogContent>
    );
};